import React, { useEffect, useState } from 'react';
import { api } from './auth';

const fmt = (c) => `R${(c / 100).toFixed(2)}`;

export default function AdminBilling({ user }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/billing').then(r => setData(r.data)).finally(() => setLoading(false));
  }, []);

  const totals = data.reduce((acc, c) => ({
    monthly_fee: acc.monthly_fee + c.totals_cents.monthly_fee,
    user_fees: acc.user_fees + c.totals_cents.user_fees,
    voice: acc.voice + c.totals_cents.voice_mandates,
    pdf: acc.pdf + c.totals_cents.pdf_mandates,
    total: acc.total + c.totals_cents.total,
  }), { monthly_fee: 0, user_fees: 0, voice: 0, pdf: 0, total: 0 });

  const isSuper = user.role === 'super_admin';

  return (
    <div style={card}>
      <h2 style={{ fontSize: 17, fontWeight: 600, margin: '0 0 4px 0' }}>
        {isSuper ? 'Billing — invoice all companies' : 'Your billing — current month'}
      </h2>
      <p style={{ fontSize: 12, color: '#6B7280', marginBottom: 20 }}>
        {isSuper ? 'Per-company breakdown of charges to be invoiced this month.' : 'What your company will be invoiced this month.'}
      </p>

      {loading ? <p style={{ color: '#9CA3AF' }}>Loading…</p> : (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(160px,1fr))', gap: 10, marginBottom: 24 }}>
            <Stat label="Monthly fees" value={fmt(totals.monthly_fee)} />
            <Stat label="User fees" value={fmt(totals.user_fees)} />
            <Stat label="Voice mandates" value={fmt(totals.voice)} />
            <Stat label="PDF mandates" value={fmt(totals.pdf)} />
            <Stat label={isSuper ? 'Grand total' : 'Total'} value={fmt(totals.total)} accent />
          </div>

          {data.length === 0 ? <p style={{ color: '#9CA3AF' }}>No billing data.</p> : (
            <div style={{ overflowX: 'auto' }}>
              <table style={tbl}>
                <thead><tr style={{ background: '#F8F9FB', textAlign: 'left' }}>
                  {isSuper && <th style={th}>Company</th>}
                  <th style={{ ...th, textAlign: 'right' }}>Monthly</th>
                  <th style={{ ...th, textAlign: 'right' }}>Users × rate</th>
                  <th style={{ ...th, textAlign: 'right' }}>Voice × rate</th>
                  <th style={{ ...th, textAlign: 'right' }}>PDF × rate</th>
                  <th style={{ ...th, textAlign: 'right' }}>Total</th>
                </tr></thead>
                <tbody>
                  {data.map(c => (
                    <tr key={c.company_id} style={{ borderBottom: '0.5px solid #F3F4F6' }}>
                      {isSuper && <td style={td}><strong>{c.company_name}</strong></td>}
                      <td style={tdR}>{c.billing_enabled.monthly_fee
                        ? <><strong>{fmt(c.totals_cents.monthly_fee)}</strong><br /><span style={muted}>{fmt(c.rates.monthly_fee_cents)}/mo</span></>
                        : <span style={off}>off</span>}</td>
                      <td style={tdR}>{c.billing_enabled.per_user
                        ? <><strong>{fmt(c.totals_cents.user_fees)}</strong><br /><span style={muted}>{c.active_users} × {fmt(c.rates.user_monthly_cents)}</span></>
                        : <span style={off}>off</span>}</td>
                      <td style={tdR}>{c.billing_enabled.voice_mandates
                        ? <><strong>{fmt(c.totals_cents.voice_mandates)}</strong><br /><span style={muted}>{c.voice_mandates} × {fmt(c.rates.voice_mandate_cents)}</span></>
                        : <span style={off}>off</span>}</td>
                      <td style={tdR}>{c.billing_enabled.pdf_mandates
                        ? <><strong>{fmt(c.totals_cents.pdf_mandates)}</strong><br /><span style={muted}>{c.pdf_mandates} × {fmt(c.rates.pdf_mandate_cents)}</span></>
                        : <span style={off}>off</span>}</td>
                      <td style={{ ...tdR, fontWeight: 600, fontSize: 14 }}>{fmt(c.totals_cents.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}

function Stat({ label, value, accent }) {
  return <div style={{ background: accent ? '#111827' : '#F8F9FB', color: accent ? '#fff' : '#111827', borderRadius: 10, padding: '14px 16px', border: accent ? 'none' : '1px solid #E5E7EB' }}>
    <p style={{ fontSize: 11, color: accent ? 'rgba(255,255,255,0.7)' : '#6B7280', textTransform: 'uppercase', margin: 0, marginBottom: 4, letterSpacing: 0.5 }}>{label}</p>
    <p style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>{value}</p>
  </div>;
}

const card = { background: '#fff', borderRadius: 16, border: '1px solid #E5E7EB', padding: '20px 24px' };
const tbl = { width: '100%', borderCollapse: 'collapse', fontSize: 13 };
const th = { padding: '10px 12px', fontWeight: 500, fontSize: 11, color: '#6B7280', textTransform: 'uppercase', borderBottom: '1px solid #E5E7EB' };
const td = { padding: '10px 12px', color: '#111827' };
const tdR = { ...td, textAlign: 'right' };
const muted = { fontSize: 10, color: '#9CA3AF' };
const off = { color: '#D1D5DB', fontSize: 11, textTransform: 'uppercase' };
